<!-- Client Info Section -->
<div
  class="flex align-items-center justify-content-between p-3 border-bottom-1 border-200 surface-50 flex-shrink-0"
  data-testid="client-info-section"
>
  @if (isLoading()) {
    <div class="flex align-items-center gap-3">
      <p-avatar
        shape="circle"
        size="large"
        styleClass="shadow-2 bg-gray-300"
      />
      <div class="flex flex-column gap-2">
        <div class="h-1rem w-10rem bg-gray-300 border-round"></div>
        <div class="h-0-75rem w-6rem bg-gray-200 border-round"></div>
      </div>
    </div>
  }
  
  @if (error()) {
    <div class="text-red-500 text-sm">{{ error() }}</div>
  }
  
  @if (!isLoading() && !error() && currentClient) {
    <div class="flex align-items-center gap-3">
      @if (currentClient.clt_image || currentClient.image) {
        <p-avatar
          [image]="currentClient.clt_image || currentClient.image"
          shape="circle"
          size="large"
          styleClass="shadow-2"
          [attr.data-testid]="'client-avatar-' + (currentClient.clt_id || currentClient.id)"
        />
      }
      @if (!currentClient.clt_image || !currentClient.image) {
        <p-avatar
          [label]="client2LetterName(currentClient.clt_full_name) | titlecase | shortName"
          shape="circle"
          size="large"
          styleClass="shadow-2 bg-primary"
          [attr.data-testid]="'client-avatar-' + (currentClient.clt_id || currentClient.id)"
        />
      }
      <div class="flex flex-column">
        <a
          href="javascript:void(0)"
          class="text-primary text-lg font-bold no-underline hover:text-primary-600 transition-colors transition-duration-200"
          [attr.data-testid]="'client-name-' + (currentClient.clt_id || currentClient.id)"
        >
          {{ currentClient.clt_full_name || currentClient.full_name }}
        </a>
        <span
          class="text-600 text-sm mt-1"
          [attr.data-testid]="'client-id-' + (currentClient.clt_id || currentClient.id)"
        >
          {{ 'FREEZE.FREEZE_SIDEBAR.CLIENTID' | translate }} -
          {{ currentClient.clt_id || currentClient.id }}
        </span>
      </div>
    </div>
    <div
      [innerHTML]="clientStatus(currentClient)"
      [attr.data-testid]="'client-status-' + (currentClient.clt_id || currentClient.id)"
    ></div>
  }
</div>
